import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Globe, ChevronDown, Calculator } from 'lucide-react';
const navLinks = [{
  label: 'Home',
  href: '/'
}, {
  label: 'Services',
  href: '/services',
  children: [{
    label: 'House Clearance',
    href: '/services/house-clearance'
  }, {
    label: 'Office Removals',
    href: '/services/office-removals'
  }, {
    label: 'Commercial Waste',
    href: '/services/commercial-waste'
  }, {
    label: 'Garden Waste',
    href: '/services/garden-waste'
  }, {
    label: 'Overseas Removals',
    href: '/services/overseas-removals'
  }, {
    label: 'Estate Agent Clearance',
    href: '/services/estate-agent'
  }, {
    label: '— Cost Calculator',
    href: '/calculator'
  }]
}, {
  label: 'Portfolio',
  href: '/portfolio'
}, {
  label: 'Contracts',
  href: '/contracts'
}, {
  label: 'Blog',
  href: '/blog'
}, {
  label: 'About',
  href: '/about'
}, {
  label: 'Contact',
  href: '/contact'
}];
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileOpen(false);
  }, [location]);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm shadow-sm'}`} data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="flex items-center justify-between h-16 lg:h-20" data-id="element-140">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-id="element-141">
            <div className="w-9 h-9 rounded-full flex items-center justify-center" style={{
            backgroundColor: '#1B8F4B'
          }} data-id="element-142">
              <Globe className="w-5 h-5 text-white" data-id="element-143" />
            </div>
            <div data-id="element-144">
              <span className="font-bold text-lg leading-none" style={{
              fontFamily: 'Montserrat, sans-serif',
              color: '#1F2937'
            }} data-id="element-145">
                Universal{' '}
                <span style={{
                color: '#1B8F4B'
              }} data-id="element-146">
                  Global Logistics
                </span>
              </span>
              <p className="text-xs leading-none" style={{
              color: '#1B8F4B',
              fontFamily: 'Open Sans, sans-serif'
            }} data-id="element-147">
                Green, Clean, Always on Time.
              </p>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-148">
            {navLinks.map(link => link.children ? <div key={link.label} className="relative group" data-id="element-149">
                  <button className="flex items-center gap-1 px-3 py-2 text-sm font-semibold rounded-md transition-colors hover:text-[#1B8F4B]" style={{
              color: location.pathname.startsWith('/services') || location.pathname === '/calculator' ? '#1B8F4B' : '#1F2937'
            }} onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-150">
                    {link.label} <ChevronDown className="w-3 h-3" data-id="element-151" />
                  </button>
                  <div className={`absolute top-full left-0 mt-1 w-56 bg-white rounded-xl shadow-xl border border-gray-100 py-2 transition-all duration-200 ${servicesOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'}`} onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-152">
                    {link.children.map(child => <Link key={child.href} to={child.href} className="block px-4 py-2 text-sm text-gray-700 hover:bg-green-50 hover:text-[#1B8F4B] transition-colors" data-id="element-153">
                        {child.label}
                      </Link>)}
                  </div>
                </div> : <Link key={link.href} to={link.href} className="px-3 py-2 text-sm font-semibold rounded-md transition-colors hover:text-[#1B8F4B]" style={{
            color: location.pathname === link.href ? '#1B8F4B' : '#1F2937'
          }} data-id="element-154">
                  {link.label}
                </Link>)}
          </nav>

          {/* CTA */}
          <div className="hidden lg:flex items-center gap-3" data-id="element-155">
            <a href="tel:+447405641227" className="flex items-center gap-1.5 text-sm font-semibold" style={{
            color: '#1F2937'
          }} data-id="element-156">
              <Phone className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-157" />
              07405 641227
            </a>
            <Link to="/contact" className="px-5 py-2.5 rounded-lg text-sm font-bold text-white transition-all duration-200 hover:opacity-90 hover:shadow-md" style={{
            backgroundColor: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-158">
              Get a Quote
            </Link>
          </div>

          {/* Mobile toggle */}
          <button className="lg:hidden p-2 rounded-md" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu" data-id="element-159">
            {mobileOpen ? <X className="w-6 h-6" data-id="element-160" /> : <Menu className="w-6 h-6" data-id="element-161" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg" data-id="element-162">
          <div className="px-4 py-4 space-y-1" data-id="element-163">
            {navLinks.map(link => <div key={link.label} data-id="element-164">
                <Link to={link.href} className="block px-3 py-2.5 text-sm font-semibold rounded-md hover:bg-green-50 hover:text-[#1B8F4B] transition-colors" style={{
            color: '#1F2937'
          }} data-id="element-165">
                  {link.label}
                </Link>
                {link.children && <div className="pl-4 mt-1 space-y-1" data-id="element-166">
                    {link.children.map(child => <Link key={child.href} to={child.href} className="block px-3 py-2 text-sm text-gray-600 hover:text-[#1B8F4B] transition-colors" data-id="element-167">
                        {child.label}
                      </Link>)}
                  </div>}
              </div>)}
            <div className="pt-3 border-t border-gray-100 flex flex-col gap-2" data-id="element-168">
              <a href="tel:+447405641227" className="flex items-center gap-2 px-3 py-2 text-sm font-semibold" style={{
            color: '#1F2937'
          }} data-id="element-169">
                <Phone className="w-4 h-4" style={{
              color: '#1B8F4B'
            }} data-id="element-170" />{' '}
                07405 641227
              </a>
              <Link to="/contact" className="block text-center px-5 py-3 rounded-lg text-sm font-bold text-white" style={{
            backgroundColor: '#1B8F4B'
          }} data-id="element-171">
                Get a Free Quote
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}